import React from 'react';
import { makeStyles, Theme, createStyles } from '@material-ui/core';
import { timeToPixels } from '../scheduleHelpers';

interface Props {
  travelTime: number;
  engineerUtilisation?: number;
}

const useStyles = makeStyles<Theme, { travelTimeWidth: number }>(
  theme => {
    const defaultFontStyles = {
      fontSize: 10,
      fontWeight: 600,
      color: theme.palette.aegis.colour.grey.darker
    };

    return createStyles({
      container: {
        display: 'flex',
        alignItems: 'center'
      },
      travelLine: {
        marginLeft: 4,
        marginRight: 4,
        height: 4,
        background: theme.palette.aegis.colour.grey.darker,
        width: ({ travelTimeWidth }) => travelTimeWidth
      },
      travelTime: {
        '&:first-child': {
          marginLeft: theme.spacing(1)
        },
        ...defaultFontStyles,
        marginLeft: theme.spacing(0.5)
      },
      evText: {
        ...defaultFontStyles,
        fontSize: 12
      },
      utilisation: {
        ...defaultFontStyles,
        marginLeft: 'auto'
      }
    });
  },
  { name: 'EngineerTravelTime' }
);

export const EngineerTravelTime = ({
  travelTime,
  engineerUtilisation
}: Props) => {
  // if travel time is more than 3h always set the width to 60 pixels
  const travelTimeWidth = travelTime >= 180 ? 60 : timeToPixels(travelTime, 3);
  const classes = useStyles({ travelTimeWidth });

  return (
    <div className={classes.container} data-testid="engineerTravelTime">
      <>
        <div className={classes.travelTime} data-testid="travelTime">
          {travelTime}min
        </div>
        {engineerUtilisation !== undefined ? (
          <div
            className={classes.utilisation}
            data-testid="engineerUtilisation"
          >
            {engineerUtilisation}% Busy
          </div>
        ) : null}
      </>
    </div>
  );
};
